export function generateMessageNo() {
  const ip = _generateIp();
  const timestamp = _generateTimestamp();
  const pidOrTid = _generatePidOrTid();
  const sequenceNo = _generateSequenceNO();
  return `555${ip}${timestamp}${pidOrTid}${sequenceNo}`;
}

/**
 * 获取制定数量的随机数
 * @param  {[type]} len [description]
 * @return {[type]}     [description]
 */
const _getRandomNumStr = len => {
  let str = '';
  while (str.length < len) {
    const newNum = Math.floor(Math.random() * 10).toString();
    str += newNum;
  }
  return str;
};

/**
 * 8位，16进制IP
 * @return {[type]} [description]
 */
const _generateIp = () => {
  return _getRandomNumStr(8);
};

/**
 * 10位（第一位是1）第一位作为采样位，置为8|9表示模调采样，9预留给应用打印debug
 * @return {[type]} [description]
 */
const _generateTimestamp = () => {
  const timestampStr = parseInt(new Date().getTime() / 1000)
    .toString()
    .slice(-9);
  return `8${timestampStr}`;
};

/**
 * 5位
 * PID或者TID严格控制<5位
 * @return {[type]} [description]
 */
const _generatePidOrTid = () => {
  return _getRandomNumStr(5);
};

/**
 * 推荐用5位
 * PID或者TID严格控制<5位
 * @return {[type]} [description]
 */
const _generateSequenceNO = () => {
  return _getRandomNumStr(5);
};
